import AsinTile from './AsinTile'
import useStore from '../../store';
import { ThreeElements } from '@react-three/fiber';
import { zoneFilter } from 'src/filter/globalFilter';


function AsinDance(props: ThreeElements['group']) {
  const state = useStore((state) => state);
  const asinTiles = useStore((state) => state.asinTiles).filter((tile) => zoneFilter(tile, state));
  return (
    <group {...props}>
      { asinTiles.map((tile) => (
        <AsinTile tileData={tile}
          key={tile.tileId}
        />
      )) }
    </group>
  )
}

export default AsinDance;
